import logo from './logo.svg';
import './App.css';
import Layout from './Layout/Layout';
import { BrowserRouter } from 'react-router-dom';
import { useState } from 'react';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

function App({ districtDetails }) {
  const[isClass, setClass] = useState();
  const[isActive, setActive] = useState();

  
  // useEffect(() => {
  //   document.body.classList.toggle('active', isClass)},[isClass]);
  const setClassName = () =>{
    if(window.innerWidth < 993){
      setClass(!isClass);
    }
  }

  const darkMode = ()=>{
    setActive(!isActive);
  }
  // Handle clicks on the backdrop (when backdrop is clicked, nav-slided should disappear)
  const handleBackdropClick = (event) => {
    if (event.target.classList.contains('container') && isClass) {
      setClass(!isClass);
    }
  };
  return (
    <div className={`container ${isClass ? 'nav-slided' : ''} ${isActive ? 'darkMode' : ''}` } onClick={handleBackdropClick}>
      <BrowserRouter>
         <Layout setClassName={setClassName}  isClass={isClass} darkMode={darkMode} districtDetails={districtDetails}/>
      </BrowserRouter>
      
    </div>
  );
}
export default App;